import React from "react";
import { AlertsContext } from "../context/alerts";

export default function useAlerts() {
  return React.useContext(AlertsContext);
}
